









































import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import { ProductDetailedStatDeklaracje } from "@/store/modules/statsDeklaracje/types";
import StatsDetails from "@/views/elements/StatsDetails.vue";
const StatsDeklaracjeModule = namespace('StatsDeklaracjeModule')
import _ from 'lodash'

@Component({
    components: { StatsDetails }
})
export default class StatsDetailsDeklaracje extends Vue {

    @StatsDeklaracjeModule.Getter('detailedStatsDeklaracje') detailedStatsDeklaracje! :Array<object>;
    @StatsDeklaracjeModule.Getter('detailedStatsDeklaracjeLoading') detailedStatsDeklaracjeLoading! :boolean;
    @StatsDeklaracjeModule.Action('getDetailedStatsDeklaracjeBetweenDatesForProduct') getDetailedStatsDeklaracjeBetweenDatesForProduct: any;

    get modulPrintTotal():number {
        let modulPrintTotal = _.countBy(this.detailedStatsDeklaracje, function(o:ProductDetailedStatDeklaracje) {return o.modul == 'DRUK'}).true;
        return (modulPrintTotal == undefined) ? 0 : modulPrintTotal;
    }

    get modulEdeklaracjeTotal():number {
        let modulEdeklaracjeTotal = _.countBy(this.detailedStatsDeklaracje, function(o:ProductDetailedStatDeklaracje) {return o.modul == 'EDEKLARACJE'}).true;
        return (modulEdeklaracjeTotal == undefined) ? 0 : modulEdeklaracjeTotal;
    }

    get modulPrintPercent():number {
        if (!this.detailedStatsDeklaracje.length) return 0;
        return (this.modulPrintTotal / this.detailedStatsDeklaracje.length) * 100;
    }

    get modulEdeklaracjePercent():number {
        if (!this.detailedStatsDeklaracje.length) return 0;
        return (this.modulEdeklaracjeTotal / this.detailedStatsDeklaracje.length) * 100;
    }

    get kwotaTotal():number {
        return _.sumBy(this.detailedStatsDeklaracje, 'kwota');
    }

    get kwotaAverage():number {
        if (!this.detailedStatsDeklaracje.length) return 0;
        return this.kwotaTotal / this.detailedStatsDeklaracje.length;
    }

    get statsFromWindowsPercent():number {
        if (!this.detailedStatsDeklaracje.length) return 0;
        return (_.filter(this.detailedStatsDeklaracje, function(o:ProductDetailedStatDeklaracje) { if (o.stats_uruchomienia_rozsz.os == 'Windows') return o }).length / this.detailedStatsDeklaracje.length) * 100;
    }
}
